import { PLAYLIST } from '../components/player/SoundSwitcher'; 

// ⚡ État initial du lecteur audio
const initState = {
  isPlaying: false,
  currentTrack: null,
  isMute: false,
  isLoop: false,
  isPlaylistLoop: false,
  volume: 50,         // 🚀 Volume global par défaut
  seekTime: null,      // 📅 Temps demandé par la barre de défilement
  currentTime: 0, // 🚀 Nouveau : Temps écoulé en direct
  duration: 0     // 🚀 Nouveau : Durée totale du MP3
};

const playerReducer = (state = initState, action) => {
  switch (action.type) {
    case 'SET_TRACK':
      return {
        ...state,
        currentTrack: action.payload,
        isPlaying: true, // Lance la lecture automatiquement quand on choisit un son
         seekTime: null
      };
    case 'TOGGLE_PLAY':
      return {
        ...state,
        isPlaying: !state.isPlaying // Alterne entre true et false
      };
    case 'STOP_TRACK':
      return {
        ...state,
        isPlaying: false,
        currentTrack: null, // Réinitialise tout
        seekTime: null,
        currentTime: 0 // 🌟 Bonus : remet aussi le curseur graphique au début à l'arrêt
      };
    case 'TOGGLE_MUTE':
      return {
        ...state,
        isMute: !state.isMute // inverse la valeur (true devient false, et inversement)
      };
    case 'TOGGLE_LOOP':
      return {
        ...state,
        isLoop: !state.isLoop,
        isPlaylistLoop: state.isPlaylistLoop ? false : state.isPlaylistLoop // Optionnel : désactive la playlist si on active le morceau unique
      };
    case 'TOGGLE_PLAYLIST_LOOP':
      return {
        ...state,
        isPlaylistLoop: !state.isPlaylistLoop,
        isLoop: state.isLoop ? false : state.isLoop // Optionnel : désactive la boucle unique si on active la playlist
      };
    case 'NEXT_TRACK':
      if (!state.currentTrack) return state;
      // Trouver l'index actuel dans la playlist
      const currentIndex = PLAYLIST.findIndex(track => track.id === state.currentTrack.id);
      // Calculer l'index suivant (revient à 0 si on dépasse la fin)
      const nextIndex = (currentIndex + 1) % PLAYLIST.length;
       const nextTrack = PLAYLIST[nextIndex];
      return {
        ...state,
        currentTrack: {
        id: nextTrack.id,
        title: nextTrack.title,
        url: nextTrack.src
        },
        isPlaying: true,
        seekTime: null,
        currentTime: 0
      };
    case 'SET_VOLUME':
      return {
        ...state,
        volume: action.payload
      };
    case 'SET_SEEK_TIME':
      return {
        ...state,
        seekTime: action.payload
      };
    case 'UPDATE_TIME':
      return {
        ...state,
        currentTime: action.payload
      };
    case 'SET_DURATION':
      return {
        ...state,
        duration: action.payload
      };

    default:
      return state;
  }
};

export default playerReducer;
